import { render, staticRenderFns } from "./counsels-report.vue?vue&type=template&id=477a05fc&"
import script from "./counsels-report.vue?vue&type=script&lang=js&"
export * from "./counsels-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports